import React, { useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
//import { Html } from '@react-three/drei';
import Stars from './components/Stars';

import ColorContext from './components/ColorContext';
import WorkExperienceTimeline from './components/WorkExperienceTimeline';
import ProjectsSection from "./components/ProjectsSection";


import spatialData from './assets/spatial_data.png';
import watchlist from './assets/watchlist.jpg';
import webscaler from './assets/webscaler.jpg';
import assistant from './media/ai_assistant_demo.mp4'
import assistant_img from './media/ai_assistant_img.png'
import reactAgent from './media/reactAgent.mp4'
import reactAgentImg from './media/reactAgentImg.png'
import job_info from './media/job_info_demo.mp4'
import job_info_img from './media/job_info_img.png'
import merchant_demo from './media/demo_merchants.mp4'
import merchant_img from './media/demo_merchants_img.png'
import HeroMenu from "./components/HeroMenu";
import SkillsSpecial from './components/SkillsSpecial';

import capstone_demo from './media/capstone_video.mp4'
import capstone_img from './media/capstone_img.png'

import codehinter_img from './media/codehinter.jpg'
import codehinter_demo from './media/codehinter_demo_6x.mov'
import { Routes, Route } from "react-router-dom";
import ProjectDetail from "./components/ProjectDetail";
import CanvasErrorBoundary from "./components/CanvasErrorBoundary";







function App() {
  const [dpr, setDpr] = useState(window.devicePixelRatio);
  const [color, setColor] = useState(0x00ffff);

  const portfolioItems = [
    {
      slug: "codehinter-ra",
      image: codehinter_img,
      title: "CodeHinter",
      description:
        "Agentic VS Code Extension to help Novice Programmer Learn Debugging",
      github: "",
      live: "", // optional
      demo: codehinter_demo, // optional (video)
      tech: "LangGraph, TypeScript, RAG, FastAPI, OpenAI API",
    },
    {
      slug: "smart-desk",
      image: capstone_img, // TEMP thumbnail
      title: "AI Powered Smart Desk",
      description: "Smart Desk with builtin AI assistant and Automated Wireless Charging",
      github: "https://github.com/mattChrisP/CapstoneBE",
      live: "",
      demo: capstone_demo,
      tech: "Object Detection, Raspberry Pi, OpenAI API, Pose Estimation",
    },
    {
      slug: "personal-assistant",
      image: assistant_img, // TEMP thumbnail
      title: "Personal AI Assistant",
      description: "My personal AI assistant",
      github: "",
      live: "",
      demo: assistant,
      tech: "LangChain",
    },
        {
      slug: "react-agent",
      image: reactAgentImg, // TEMP thumbnail
      title: "Advanced Reasoning with ReAct Agent",
      description: "",
      github: "",
      live: "",
      demo: reactAgent,
      tech: "",
    },


    {
      slug: "merchant-sales",
      image: merchant_img, // TEMP thumbnail
      title: "Merchant Sales",
      description: "AI Agent to help Merchant sell their products",
      github: "",
      live: "",
      demo: merchant_demo,
      tech: "",
    },

    {
      slug: "job-search-automation",
      image: job_info_img, // TEMP: put any image here if you don’t have one yet
      title: "Job Search Automation",
      description:
        "Help me search for jobs daily, make me a customized cover letter and keywords suggestion to pass ATS",
      github: "https://github.com/mattChrisP/job_info",
      live: "",
      demo: job_info, // mp4
      tech: "LangChain, API, SMTP, NLP",
    },
    {
      slug: "geospatial-search",
      image: spatialData,
      title: "Efficient Geospatial Search",
      description:
        "Easily mark any landmark points on google map, realtime efficient query of landmark based on category",
      github: "https://github.com/mattChrisP/Spatial-Data-Simulator",
      live: "", // optional
      demo: "", // optional (video)
      tech: "Rtree, Google Maps API, Flask",
    },
    {
      slug: "watchlist-app",
      image: watchlist,
      title: "Watchlist Native App",
      description: "Native App project to store your favourite movies",
      github: "https://github.com/mattChrisP/watchio_app",
      live: "",
      demo: "",
      tech: "Flutter, Firebase",
    },


    {
      slug: "image-scaler",
      image: webscaler,
      title: "Image Scaler",
      description: "A project to scale your image to higher resolution",
      github: "https://github.com/mattChrisP/WebScaler",
      live: "",
      demo: "",
      tech: "Golang, RabbitMQ, React, Go",
    },
  ];


  useEffect(() => {
    const handleResize = () => {
      setDpr(window.devicePixelRatio);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="app-container">
    <div style={{position: 'absolute',height: '100%', width: '100%'}} >

    <ColorContext.Provider value={{ color, setColor }}>

      <div style={{
          flexWrap: 'wrap',
          alignContent: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',

          paddingTop: '20px', // Add padding to the top
        }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          top: -700,
          bottom: 0,
          right: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1,
          position: 'inherit',
          overflow: 'hidden',
        }}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <HeroMenu />
                  <ProjectsSection items={portfolioItems} />
                  <div id="skills" style={{ zIndex: 10, width: "100%" }}>
                    <SkillsSpecial />
                  </div>
                  <section id="experience" style={{ zIndex: 10, width: "100%", height: "100%" }}>
                    <WorkExperienceTimeline />
                  </section>
                </>
              }
            />
            <Route path="/projects/:slug" element={<ProjectDetail items={portfolioItems} />} />
          </Routes>
        </div>
        

      </div>
      <CanvasErrorBoundary fallback={null}>
        <div
          style={{
            position: "fixed",
            inset: 0,
            pointerEvents: "none",
            zIndex: 0,
          }}
        >
          <Canvas
            camera={{
              fov: 120,
              aspect: window.innerWidth / window.innerHeight,
              near: 1,
              far: 1000,
              position: [0, 0, 1],
              rotation: [Math.PI / 2, 0, 0],
            }}
            dpr={dpr}
          >
            <React.Suspense fallback={null}>
              <Stars />
            </React.Suspense>
          </Canvas>
        </div>
      </CanvasErrorBoundary>



    </ColorContext.Provider>
    

    </div>

    </div>
  );
}
          
export default App;
